import RapidBackground from '../images/business/banner-rapid.jpg';
import UnlimitedBackground from '../images/business/banner-unlimited.jpg';
import NeedsBackground from '../images/business/banner-needs.jpg';

const data = [
  {
    title: 'Rapid',
    sub: 'step1-sub',
    text: 'step1-text',
    image: RapidBackground,
  },
  {
    title: 'Unlimited',
    sub: 'step2-sub',
    text: 'step2-text',
    image: UnlimitedBackground,
  },
  {
    title: 'Needs-oriented',
    sub: 'step3-sub',
    text: 'step3-text',
    image: NeedsBackground,
  },
];

export default data;
